<template>
  <div class="volunteering-event-item">
    <h4>{{ item.description }}</h4>
    <div class="volunteering-event-item__dates secondary_text">
      <span class="secondary_text_slim">{{ getDates() }}</span>
    </div>
    <div class="volunteering-event-item__role secondary_text">
      Роль:
      <span class="secondary_text_slim">{{ item.role?.toLowerCase() }}</span>
    </div>
  </div>
</template>

<script setup>
  import dayjs from 'dayjs';
  import updateLocale from 'dayjs/plugin/updateLocale';

  const props = defineProps({
    item: {
      type: Object,
      required: true,
    },
  });

  const getDates = () => {
    dayjs.extend(updateLocale);
    dayjs.updateLocale('ru', {
      months: [
        'января',
        'февраля',
        'марта',
        'апреля',
        'мая',
        'июня',
        'июля',
        'августа',
        'сентября',
        'октября',
        'ноября',
        'декабря',
      ],
    });

    const startDj = dayjs(props.item.startedAt).locale('ru');
    const endDj = dayjs(props.item.endedAt).locale('ru');
    const monthStart = startDj.format('MMMM');
    const monthEnd = endDj.format('MMMM');
    const dayStart = startDj.date();
    const dayEnd = endDj.date();

    if (startDj.year() === endDj.year()) {
      if (startDj.month() === endDj.month()) {
        if (dayStart === dayEnd) {
          return `${dayStart} ${monthEnd} ${endDj.year()}`;
        } else {
          return `${dayStart} - ${dayEnd} ${monthEnd} ${endDj.year()}`;
        }
      } else {
        return `${dayStart} ${monthStart} - ${dayEnd} ${monthEnd} ${endDj.year()}`;
      }
    } else {
      return `${dayStart} ${monthStart} ${startDj.year()} - ${dayEnd} ${monthEnd} ${endDj.year()}`;
    }
  };
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors' as *;

  .volunteering-event-item {
    background: $color-bg-primary-white;
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    margin: 0 0 16px 0;

    &__role {
      margin: 16px 0 0 0;
    }
  }

  .secondary_text {
    font-family: Nunito Sans, sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: $color-text-secondary-grey-profile;

    &_slim {
      font-weight: 400;
    }
  }
</style>
